module.exports = __webpack_public_path__ + "static/media/logo-award-european-customer-centricity-2021.1f71407d.png";